<template>
  <div>
    <!-- 商品标记 -->
    <el-dialog :title="$t('message.productMarking')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="780px" center @close="$parent.labelConfigList" v-loading="loading">
      <div class="content">
        <!-- 新增 -->
        <div class="row">
          <el-button type="success" size="mini" @click="labelList.push({ name: '', id: '', icon: '' })"> {{
            $t("message.add")
          }}</el-button>
        </div>
        <div class="table">
          <ol>
            <li class="flex05">
              icon
            </li>
            <!-- 标记名称设置 -->
            <li class="flex15">
              {{ $t("message.tagNameSetting") }}
            </li>
            <!-- 操作 -->
            <li class="flex05">
              {{ $t("message.operation") }}
            </li>
          </ol>
          <ul v-for="(item, index) in labelList" :key="index">
            <li class="flex05" @click="i = index">
              <el-upload class="upload-demo" :action="baseURL + '/api/common/uploadFile'" :before-upload="befoUpload"
                :http-request="httpup" multiple :show-file-list="false">
                <el-button size="small" type="primary" class="primary" v-if="!item.icon">上传图片</el-button>
                <img :src="item.icon" alt="" v-else style="width: 80px;min-height: 20px;">
              </el-upload>
            </li>
            <!-- 标记名称设置 -->
            <li class="flex15">
              <el-input v-model="item.name" @blur="changeInput(item)"></el-input>
            </li>
            <!-- 操作 -->
            <li class="flex05">
              <el-button class="dark" type="primary" size="mini" @click="delItem(item, index)">{{ $t('message.delete')
              }}</el-button>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {

  data() {
    return {
      dialogVisible: false,
      labelList: [],
      loading: false,
      i: 0,
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.labelConfigList()
      }
    }
  },
  methods: {
    labelConfigList() {
      this.$api.warehouseApi.labelConfigList().then((res) => {
        this.labelList = res.data
      })
    },
    // 新增修改
    changeInput(item) {
      if (item.id) {
        let datas = {
          label_id: item.id,
          name: item.name,
          icon: item.icon
        }
        this.$api.warehouseApi.labelUpdate(datas)
      } else {
        this.$api.warehouseApi.labelStore({ name: item.name, icon: item.icon }).then(res => {
          this.labelConfigList()
        })
      }
      this.loading = false
    },
    //删除
    delItem(item, index) {
      if (item.id) {
        this.$api.warehouseApi.labelGoodsCount({ label_id: item.id }).then(res => {
          this.$confirm(
            '有' + `<span style='color:red;font-size:16px'>${res.data}</span>` + '条商品已经使用该标记，是否删除该标记，删除后对应商品的该标记内容全部清除',
            this.$t("message.hint"),
            {
              confirmButtonText: this.$t("message.ok"), //确定
              cancelButtonText: this.$t("message.cancel"), //取消
              type: "warning",
              center: true,
              dangerouslyUseHTMLString: true
            }
          )
            .then(() => {
              this.$api.warehouseApi.labelDelete({ label_id: item.id }).then(res => {
                this.labelList.splice(index, 1)
              })
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消操作",
              });
            });

        })


      } else {
        this.labelList.splice(index, 1)
      }
    },
    // 图片上传事件
    async httpup(file) {
      this.loading = true
      let data = await this.createClient(file)
      this.labelList[this.i].icon = data.data
      this.changeInput(this.labelList[this.i])
      this.$forceUpdate()
      // this.successup(data.data)
    },
    befoUpload(file) {
      const isJPG =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) != -1;
      if (!isJPG) {
        this.$message.error("请上传图片");
        return isJPG;
      }

    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {

    margin-bottom: 20px;
    text-align: right;

  }

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;


      li {
        padding: 24px 0;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }
  }

  /deep/.el-input {
    width: 60%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>